import {HttpModelConverter} from '../../../../../../core/converter/httpModel.converter';
import {Scan3dModel} from '../scan3d.model';
import {DocumentSummaryConverter} from '../../../../../../document/common/api/converter/DocumentSummary.converter';
import {Injectable} from '@angular/core';

@Injectable()
export class Scan3dConverter extends HttpModelConverter<Scan3dModel> {

    constructor(private documentSummaryConverter: DocumentSummaryConverter) {
        super();
    }
    protected createInstance(): Scan3dModel {
        return new Scan3dModel();
    }

    protected enrichObject(result: Scan3dModel, src: Scan3dModel) {
        result.document = this.documentSummaryConverter.convert(src.document);
    }
}
